'use client';

import { useState } from 'react';
import { Header } from '@/components/layout/header';
import { OrderPanel } from '@/components/order/order-panel';

/**
 * Client island for SSR pages: owns the cart panel state so the header
 * cart button works without passing callbacks through Server Components.
 */
export function HeaderWithCart() {
  const [isOrderPanelOpen, setIsOrderPanelOpen] = useState(false);

  return (
    <>
      <Header onOpenCart={() => setIsOrderPanelOpen(true)} />
      <OrderPanel isOpen={isOrderPanelOpen} onClose={() => setIsOrderPanelOpen(false)} />
    </>
  );
}
